import sanitizeFilename from "sanitize-filename";
import { useAbsoluteUrl } from "~/composables/useAbsoluteUrl";
import type { UseHeadInput, UseSeoMetaInput } from "@unhead/vue/types";

export default defineNuxtPlugin(() => {
  function filename(filename: string) {
    return sanitizeFilename(filename);
  }

  function html(html: string) {
    const map: Record<string, string> = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#x27;",
      "/": "&#x2F;"
    };
    return html.replace(/[&<>"'/]/g, (char) => map[char] || char);
  }

  return {
    provide: {
      sanitize: { filename, html }
    }
  };
});
